var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container comprehensive-po-page" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("PO管理")]),
              _c("el-breadcrumb-item", [_vm._v("综合PO工单")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "po-other-tabs",
              on: { "tab-click": _vm.onTabClick },
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            _vm._l(_vm.poOtherTabs, function(tab) {
              return _c(
                "el-tab-pane",
                { key: tab.name, attrs: { label: tab.label, name: tab.name } },
                [_c("span", { staticClass: "po-other-tab-placeholder" })]
              )
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "search-container" },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: {
                    inline: true,
                    model: _vm.searchForm,
                    "label-width": "100px",
                    "label-position": "right"
                  }
                },
                [
                  _vm._l(_vm.searchFieldRows, function(row, rowIndex) {
                    return _c(
                      "el-row",
                      {
                        key: "search-row-" + rowIndex,
                        staticClass: "search-fields-row",
                        attrs: { gutter: 20 }
                      },
                      _vm._l(row, function(field) {
                        return _c(
                          "el-col",
                          { key: field.key, attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: field.label } },
                              [
                                field.type === "daterange"
                                  ? _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "-",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd"
                                      },
                                      model: {
                                        value: _vm.searchForm.createdRange,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "createdRange",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.createdRange"
                                      }
                                    })
                                  : field.type === "input"
                                  ? _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        placeholder: field.placeholder
                                      },
                                      model: {
                                        value: _vm.searchForm[field.model],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            field.model,
                                            $$v
                                          )
                                        },
                                        expression: "searchForm[field.model]"
                                      }
                                    })
                                  : field.type === "select"
                                  ? _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          filterable: "",
                                          placeholder: field.placeholder
                                        },
                                        on: { focus: _vm.handleSelectFocus },
                                        model: {
                                          value: _vm.searchForm[field.model],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchForm,
                                              field.model,
                                              $$v
                                            )
                                          },
                                          expression: "searchForm[field.model]"
                                        }
                                      },
                                      _vm._l(_vm.campusOptions, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: Object.values(item)[0],
                                            value: Object.values(item)[0]
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  }),
                  _c(
                    "el-row",
                    {
                      staticClass: "search-actions-row",
                      attrs: { gutter: 20 }
                    },
                    [
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c(
                          "div",
                          { staticClass: "search-button" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.handleSearch }
                              },
                              [_vm._v("点击查询")]
                            ),
                            _c(
                              "el-button",
                              { on: { click: _vm.handleReset } },
                              [_vm._v("重置")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { loading: _vm.exportLoading },
                                on: { click: _vm.debouncedExport }
                              },
                              [_vm._v(_vm._s(_vm.exportButtonText))]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v(_vm._s(_vm.tableTitle))]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.rows, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "序号",
                    width: "60",
                    align: "center"
                  }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: column.prop + "-" + index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width,
                      "min-width": column.minWidth,
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === _vm.currentTab.ticketProp
                                ? _c("span", [
                                    scope.row[column.prop]
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.dcopsDetailHref(
                                                scope.row[column.prop]
                                              ),
                                              target: "_blank",
                                              rel: "noopener noreferrer"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row[column.prop])
                                            )
                                          ]
                                        )
                                      : _c("span", [_vm._v("-")])
                                  ])
                                : column.prop === "data"
                                ? _c(
                                    "span",
                                    [
                                      _c("json-view-dialog", {
                                        attrs: {
                                          content: scope.row.data,
                                          "data-tab": _vm.activeTab,
                                          title: _vm.pushDialogTitle,
                                          width: "92%",
                                          "max-height": 640
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : column.prop === "_dcopsTicketId" &&
                                  scope.row._dcopsTicketId
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.dcopsDetailHref(
                                            scope.row._dcopsTicketId
                                          ),
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row._dcopsTicketId))]
                                    )
                                  ])
                                : _vm.isTimeColumn(column.prop)
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatTime(scope.row[column.prop])
                                      )
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.cellText(scope.row[column.prop])
                                      )
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }